var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95507 7.49632C9.79142 8.02381 9.23114 8.31875 8.70366 8.1551L5.5886 7.18864C5.06112 7.02499 4.76618 6.46471 4.92983 5.93723L5.91861 2.75021C6.08226 2.22273 6.64254 1.92779 7.17002 2.09144C7.6975 2.25509 7.99244 2.81537 7.82879 3.34285L7.58436 4.1307C10.1742 2.69175 13.4278 2.56992 16.2401 4.09003C20.2553 6.26035 21.9851 11.0291 20.439 15.179C20.2462 15.6965 19.6704 15.9598 19.1528 15.767C18.6353 15.5741 18.3721 14.9983 18.5649 14.4808C19.7645 11.2607 18.422 7.54291 15.2891 5.84945C13.0412 4.63442 10.4363 4.76682 8.40131 5.96724L9.2963 6.24492C9.82378 6.40857 10.1187 6.96884 9.95507 7.49632Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0232 16.5065C14.1853 15.9786 14.7447 15.682 15.2727 15.844L18.3906 16.8012C18.9186 16.9632 19.2152 17.5226 19.0531 18.0506L18.0739 21.2406C17.9118 21.7685 17.3524 22.0652 16.8244 21.9031C16.2965 21.741 15.9999 21.1816 16.1619 20.6536L16.4001 19.8779C13.8128 21.3088 10.5665 21.427 7.75984 19.91C3.71971 17.7262 1.99326 12.9113 3.59026 8.74337C3.78787 8.22764 4.36613 7.96976 4.88186 8.16736C5.39758 8.36497 5.65547 8.94324 5.45786 9.45896C4.21878 12.6928 5.55826 16.4465 8.71086 18.1506C10.9573 19.3648 13.5604 19.2333 15.5948 18.035L14.6858 17.756C14.1578 17.5939 13.8612 17.0345 14.0232 16.5065Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.a7dc0d337f66ae43a5378d80ead0aa6a.svg";
export { ForwardRef as ReactComponent };